import styled, { Spacing } from '@vodafoneziggo/sandwich/theme';

export const Wrapper = styled.svg`
  margin-right: ${Spacing.XS};
`;
